import { makeStyles } from '@mui/styles';
const styles = makeStyles(() => ({
  assetDataMobileContainer: {
    paddingTop: '158px',
    maxHeight: '100vh',
  },
}));

export default styles;
